import * as React from 'react';
import clsx from 'clsx';
import { useTranslator } from '@gandi/translate';
import { AddonButton } from '../AddonButton';
import { Base } from '../Base';
import { Heading } from '../Typography/Heading';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var styles = {
  "root": "Block-root_1niuH",
  "heading": "Block-heading_2xofT",
  "content": "Block-content_1BF1L",
  "buttons": "Block-buttons_2at9C",
  "dismissible": "Block-dismissible_2VPmP",
  "close": "Block-close_3gSUk",
  "stretch": "Block-stretch_1sXle"
};
function CloseButton(props) {
  const {
    __
  } = useTranslator();
  return /*#__PURE__*/_jsx(AddonButton, {
    intent: "remove",
    size: "xs",
    hitzone: "overlay",
    ...props,
    children: __('Dismiss')
  });
}
function Block({
  stretch = false,
  dismissible = false,
  onDismiss,
  children,
  className,
  ...extraProps
}) {
  return /*#__PURE__*/_jsxs(Base, {
    padding: "small",
    borderStartRadius: "1x",
    borderEndRadius: "1x",
    backgroundColor: "white",
    className: clsx(styles.root, {
      [styles.stretch]: stretch,
      [styles.dismissible]: dismissible
    }, className),
    ...extraProps,
    children: [dismissible ? /*#__PURE__*/_jsx(CloseButton, {
      className: styles.close,
      onClick: onDismiss
    }) : null, children]
  });
}
function BlockHeading({
  as = 'h3',
  fontSize = 'l',
  fontFamily,
  children: childrenProp,
  className,
  ...extraProps
}) {
  const {
    headingEnd,
    children
  } = React.Children.toArray(childrenProp).reduce((slots, child) => {
    if (/*#__PURE__*/React.isValidElement(child) && child?.props?.slot) {
      slots[child.props.slot] = child;
      return slots;
    }
    slots.children.push(child);
    return slots;
  }, {
    headingEnd: null,
    children: []
  });
  if (headingEnd) {
    return /*#__PURE__*/_jsxs(Base, {
      flex: true,
      flexWrap: true,
      flexAlignItemsCenter: true,
      gap: "xsmall",
      marginBottom: "small",
      className: clsx(styles.heading, className),
      ...extraProps,
      children: [/*#__PURE__*/_jsx(Heading, {
        as: as,
        fontSize: fontSize,
        fontFamily: fontFamily,
        marginBottom: "none",
        children: children
      }), headingEnd]
    });
  }
  return /*#__PURE__*/_jsx(Heading, {
    as: as,
    fontSize: fontSize,
    fontFamily: fontFamily,
    marginBottom: "small",
    className: clsx(styles.heading, className),
    ...extraProps,
    children: children
  });
}
function BlockContent({
  children,
  className,
  ...extraProps
}) {
  return /*#__PURE__*/_jsx(Base, {
    className: clsx(styles.content, className),
    ...extraProps,
    children: children
  });
}
function BlockButtons({
  children,
  className,
  ...extraProps
}) {
  return /*#__PURE__*/_jsx(Base, {
    flex: true,
    flexWrap: true,
    gap: "xsmall",
    marginTop: "base",
    className: clsx(styles.buttons, className),
    ...extraProps,
    children: children
  });
}
export { Block, BlockHeading, BlockContent, BlockButtons };